module.exports = __webpack_public_path__ + "img/pwd_banner.ccb11397.png";